import { EventBroker } from "@frontend/lib/utils/event-broker";

export const EVENTS = {
    INIT: 'make-editable-v2:init',
    CLOSED: 'make-editable-v2:closed',
    SAVED: 'make-editable-v2:saved',
};

export const makeEditableV2EventBroker = new EventBroker();
